import { usePagination } from '@hooks';

export type ConsumptionParams = {
  lastName?: string;
  firstName?: string;
  cuit?: string;
  fromDate?: string;
  toDate?: string;
  page?: string;
  limit?: string;
  product?: string;
  categories?: [];
};

interface UseConsumptionListProps {
  params: ConsumptionParams;
  setURLparams: () => void;
  onError?: (error: { response: { status: number } }) => void;
}

/**
 * useConsumptionList hook
 * @description This hook is used to fetch the consumption list and handle pagination
 * @param params
 * @param setURLparams
 */
const useConsumptionList = (
  customerId: number,
  { params, setURLparams, onError }: UseConsumptionListProps
) => {
  const paginationProps = usePagination('/v3/client/consumption', {
    params: customerId && params.product ? { ...params, customerId } : [],
    setURLparams,
    paramKeys: [
      'customerId',
      'lastName',
      'firstName',
      'cuil',
      'fromDate',
      'toDate',
      'page',
      'product',
      'limit',
      'areaId',
      'categories',
    ],
    onError,
  });

  return paginationProps;
};

export default useConsumptionList;
